import { Palette } from '@mui/material';
export const getStarredSpaceColors = (palette: Palette) => {
  const safePalette: any = palette || {};
  const isDark = safePalette.mode === 'dark';
  const commonColors = safePalette.common || {
    white: '#FFFFFF',
    black: '#000000',
  };
  return {
    avatarBg: isDark ? '#524d5b' : '#dfcfcfb0',
    avatarIcon: isDark ? commonColors.white : commonColors.black,
    starIcon: isDark ? '#D0BCFA' : '#452188',
    textSecondary: 'text.secondary',
  } as const;
};
